import _extends from "@swc/helpers/src/_extends.mjs";
import _object_destructuring_empty from "@swc/helpers/src/_object_destructuring_empty.mjs";
import React from 'react';
import CloseIcon from '../../Icons/CloseBold';
import { IconSize } from '../../Icons/IconWrap';
import Tag from '../Tag';
const RemovableTag = (_param)=>{
    var rest = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ React.createElement(Tag, _extends({
        postfix: /*#__PURE__*/ React.createElement(CloseIcon, {
            size: IconSize.TINY
        })
    }, rest));
};
RemovableTag.displayName = 'RemovableTag';
export default RemovableTag;
